/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Record_Type_InvalidInputs */

const es_co2_error_record_type_invalid = /** @type {(inputs: Error_Record_Type_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tipo de registro no es válido.`)
};

/**

* @param {Error_Record_Type_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_record_type_invalid = /** @type {((inputs?: Error_Record_Type_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Record_Type_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_record_type_invalid(inputs)
});